/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint no-param-reassign:  [2, { "props": false }] */
import React, { useEffect, useState } from "react";

import styles from "./CustomProductOption.module.css";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";
import brandRefreshStyles from "./CustomProductOptionBrandRefresh.module.css";
import BrandRefreshBadges from "./BrandRefreshBadges";
import BrandRefreshDescriptionModal from "./BrandRefreshDescriptionModal";
import BrandRefreshTooltip from "./BrandRefreshTooltip";

const checkIcon = require("./imgs/check-icon.svg");
const checkLightIcon = require("./imgs/check-light-icon.svg");
const infoIcon = require("./imgs/info-icon.svg");

const renderBrandRefreshPrice = (price, currency) => {
  if (!price || !(price > 0) || !currency) return null;
  return (
    <span className={brandRefreshStyles.priceModifier} data-part="price-modifier">
      (+
      {currency.symbol}
      {price.toFixed(2)}
)
    </span>
  );
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mq = window.matchMedia("(max-width: 767px)");
    const handler = e => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    if (mq.addEventListener) {
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }
    if (mq.addListener) {
      mq.addListener(handler);
      return () => mq.removeListener(handler);
    }
    return undefined;
  }, []);
  return isMobile;
};

function renderLegacySingleOption(props) {
  const {
    image,
    name,
    onChange,
    isSelected,
    price,
    currency,
    renderPrice,
    description,
    oos,
  } = props;

  const removePaddingClass =
    name.length > 12
      ? [styles.topMargin0, styles.bottomMargin0].join(" ")
      : styles.topMargin0;
  return (
    <div
      className={`${
        oos === 1 ? styles.oos : ""
      } flex md:flex-col md:items-center w-[343px] md:w-[216px] gap-2`}
    >
      <div className="w-[156px] h-[156px] md:w-[216px] md:h-[216px]">
        <img
          alt=""
          src={image}
          onError={i => {
            i.target.style.display = "none";
            return null;
          }}
          className="w-full object-contain"
        />
      </div>
      <div className="flex flex-col md:items-center md:text-center gap-2 w-[179px]">
        <h3
          className={`${removePaddingClass} md:min-h-[46px] font-montserratBold text-lg leading-[22px] tracking-[-0.1px] text-dark dark:text-white`}
        >
          {name}
        </h3>
        <p className="text-darkElevationPrimary dark:text-[#B4A5BB] text-xs leading-[14px] md:min-h-[42px]">
          {description}
        </p>
        <div>
          <div className="w-[123px] flex flex-col items-center justify-center">
            {oos === 1 ? null : (
              <div className="flex gap-3 items-center">
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onChange();
                    }
                  }}
                  onClick={onChange}
                  className={`${
                    isSelected
                      ? "bg-dark dark:bg-button border-none"
                      : "bg-white dark:bg-disabled dark:border-none border-2 border-borderLight"
                  } w-11 h-11 rounded-full flex items-center cursor-pointer`}
                >
                  <img
                    alt=""
                    src={checkLightIcon}
                    className={`${isSelected ? "hidden" : "block"} m-auto `}
                  />
                  <img
                    alt=""
                    src={checkIcon}
                    className={`${isSelected ? "block" : "hidden"} m-auto `}
                  />
                </div>
              </div>
            )}
            <p className="py-1">{renderPrice(price, currency)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function renderBrandRefreshSingleOption(props, hookState) {
  const {
    image,
    name,
    onChange,
    isSelected,
    price,
    currency,
    description,
    oos,
    metaTags = [],
  } = props;

  const { showDescription, setShowDescription, isMobile, showTooltip, setShowTooltip } = hookState;
  const toggleDescription = () => setShowDescription(prev => !prev);

  return (
    <>
      <div
        className={`${brandRefreshStyles.productCard} ${oos === 1 ? brandRefreshStyles.oosOverlay : ""}`}
        data-part="product-card"
      >
        <div className={brandRefreshStyles.imageRegion}>
          <img
            alt=""
            src={image}
            data-part="product-image"
            onError={i => {
              i.target.style.display = "none";
              return null;
            }}
            className={brandRefreshStyles.productImage}
          />
          <BrandRefreshBadges metaTags={metaTags} />
        </div>
        {description && (
          <div className={brandRefreshStyles.infoBtnWrapper}>
            <button
              type="button"
              className={brandRefreshStyles.infoBtn}
              aria-label="Show description"
              data-part="info-btn"
              onClick={isMobile ? toggleDescription : undefined}
              onMouseEnter={() => !isMobile && setShowTooltip(true)}
              onMouseLeave={() => !isMobile && setShowTooltip(false)}
            >
              <img src={infoIcon} alt="" aria-hidden="true" />
            </button>
            {!isMobile && showTooltip && <BrandRefreshTooltip description={description} />}
          </div>
        )}

        <div className={brandRefreshStyles.contentRegion}>
          <h3 className={brandRefreshStyles.productTitle} data-part="product-title">
            {name}
          </h3>

          <div className={brandRefreshStyles.footer}>
            {renderBrandRefreshPrice(price, currency) || <span />}
            {oos !== 1 && (
            <button
              type="button"
              aria-label={isSelected ? "Selected" : "Select"}
              data-part="add-btn"
              onClick={onChange}
              className={brandRefreshStyles.selectorIndicator}
              data-selected={isSelected ? "true" : "false"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M13.5 4.5L6.5 11.5L3 8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
              )}
          </div>
        </div>
      </div>

      {isMobile && showDescription && description && (
        <BrandRefreshDescriptionModal
          title={name}
          description={description}
          onClose={() => setShowDescription(false)}
        />
      )}
    </>
  );
}

function CustomSingleOption(props) {
  // Hooks must always be called unconditionally at the top level of the
  // component, regardless of which render path (legacy vs. brand refresh)
  // is ultimately used. The brand refresh path is opted into via
  // isBrandRefreshEnabled(); legacy path ignores this state entirely.
  const [showDescription, setShowDescription] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const isMobile = useIsMobile();

  if (isBrandRefreshEnabled()) {
    return renderBrandRefreshSingleOption(props, {
      showDescription,
      setShowDescription,
      isMobile,
      showTooltip,
      setShowTooltip,
    });
  }
  return renderLegacySingleOption(props);
}

export default CustomSingleOption;